import React from "react";
import StationDetailContainer from "containers/StationDetail";

const StationDetailPage = (props) => {
  return (
    <StationDetailContainer {...props} />
  );
};

export default StationDetailPage;
